import React from 'react'
import Link from 'gatsby-link'
import './style.scss';

class TopBar extends React.Component {
  render() {
    return (
			<div className="topbar">
				<div className="logo-wrap">
					<img width="800px" src="./img/strawn_logo.svg" alt="Strawn &amp; Richardson" />
				</div>
			</div>
    )
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar/index.jsx